import {ChangeDetectorRef, Component, ElementRef, Inject, Input, NgZone, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {AjoutProjetComponent} from "../../../parametre/project-parametre/ajout-projet/ajout-projet.component";
import * as feather from 'feather-icons';
import {ParametreService} from "../../../parametre/main-parametre/parametre.service";
import {Tva, TvaService} from "../../../parametre/taxe-tva/parametre-tva/tva.service";
import {Prix, PrixService} from "../../../parametre/liste-prix/prix.service";
import {MarqueService} from "../../../../services/categorie-unite-marque/marque.service";
import {Marque} from "../../../../models/marque";
import {CategorieService} from "../../../../services/categorie-unite-marque/categorie.service";
import {Categorie} from "../../../../models/categorie";
import {UniteService} from "../../../../services/categorie-unite-marque/unite.service";
import {Unite} from "../../../../models/Unite";
import {ProductsService} from "../../../../services/products/products.service";
import {Product} from "../../../../models/Product";
import {LogisticsInfo} from "../../../../models/LogisticsInfo";
import {StationService} from "../../../../services/station.service";
import {environment} from "../../../../../environments/environment";
import {Taxe, TaxeService} from "../../../parametre/taxe-tva/parametre-taxe/taxe.service";
import { ERP_AFFICHAGES_API, ErpAffichagesApi } from '@erp/affichages';
import {catchError, debounceTime, filter, finalize, map, switchMap, tap} from "rxjs/operators";
import {forkJoin, Observable, of, Subscription, throwError} from "rxjs";
import {
    CroudMarqueCategoryComponent
} from "../../../parametre/marque-and-category/croud-marque-category/croud-marque-category.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {HeaderService} from "../../../../services/header/header.service";
import {AddTaxeComponent} from "./add-taxe/add-taxe.component";
import {WarehouseService} from "../../../../services/warehouse/warehouse.service";
import {CoordinateParamsPayload, ParamTablesService} from "../../../../services/parametrage/param-tables.service";
import {FlatpickrOptions} from "ng2-flatpickr";
import {French} from "flatpickr/dist/l10n/fr.js";
import {ParametreDonneesStateService} from "../../../parametre/parametre-donnees/parametre-donnees-state.service";
import {resolveRefModuleTableDbId} from "../../../parametre/parametre-donnees/parametre-donnees-api.models";

/** Ligne « Paramètres des données » produit (libellé / type / valeur). */
export interface AddProductParamRow {
  libelle: string;
  type: AddProductParamType;
  valeur: string;
  champ_db: string;
  /** Id ligne renvoyé par GET param-tables (obligatoire pour POST coordinate-params). */
  param_table_id?: number | null;
}

/** Option ng-select pour un paramètre type liste (GET select-params/param-table/…). */
export interface AddProductSelectOption {
  label: string;
  value: string;
}

export type AddProductParamType = 'varchar' | 'date' | 'nombre' | 'select';

interface PriceBlockError {
    bascul_calcul: string;
    regles: string;
}
interface WarehouseBlockErrors {
    entrepot_id: string  ,
    minimum: string,
    maximum: string
}

@Component({
    selector: 'app-add-product',
    templateUrl: './add-product.component.html',
    styleUrls: ['./add-product.component.scss']
})

export class AddProductComponent implements OnInit {
    @ViewChild('contentWrapper') contentWrapper: ElementRef;
    private currentRoute: string;
    animation = 'fadeIn';
    messageRecu: any = "";
    private componentId = Math.random().toString(36).substring(2);
    private subscriptions = new Subscription();
    @ViewChild('addtaxe') addtaxe?: AddTaxeComponent;
    submitAttemptedStep1 = false;
    margeBeneficiaire: number = null;
    prixVente: number = null;
    priceType: string = 'HT';
    priceType2: string = 'HT';
    private calculating: boolean = false;
    selectedTva: number = 0;
    selectedTaxe: number = 0;
    finalPrice: number = 0;
    file_url = environment.url_images;
    @Input() productData: any = null;
    currentUser = JSON.parse(localStorage.getItem('currentUser'));
    clientId = this.currentUser?.id;
    stationId =
        this.currentUser?.stations?.[0]?.station_id ??
        this.currentUser?.stations?.[0]?.id ??
        this.currentUser?.station_id ??
        0;
    isLoading: boolean = false;
    marques: Marque[] = [];
    categories: Categorie[] = [];
    unites: Unite[] = [];
    taxes: any[] = [];
    tva: Tva[] = [];
    selectedPriceId!: number;
    availablePriceLists: Prix[] = []; // All available price lists from API
    selectedPriceLists: any[] = [];  // Currently selected/configured price lists
    public contentHeader: object;
    logoPreview: string | null = null;
    margePourcentage: number | null = null;
    margeValeur: number | null = null;
    steps: string[] = [
        'Type de produit',
        ' Informations sur le produit',
        ' Informations supplémentaires',
        ' Parametre des données ',
        ' Terminé'
    ];


    currentStep: number = 0;
    productIdToEdit: number;
    editMode: boolean = false;
    hasAddedPrice: boolean = false;
    isStep1Valid: boolean = false;
    isStep2Valid: boolean = false;
    isStep3Valid: boolean = false;

    numberValue: number = 0;

    minValue: number = 0;
    maxValue?: number;

    disabledValueIncrement: boolean = false;
    disabledValueDecrement: boolean = false;

    entrepots: any = {
        id: 0,
        min: 5,
        max: 4,
        entrepot: []
    }
    private updateDisabledStates(): void {
        this.disabledValueDecrement = this.numberValue <= this.minValue;

        if (this.maxValue !== undefined) {
            this.disabledValueIncrement = this.numberValue >= this.maxValue;
        } else {
            this.disabledValueIncrement = false;
        }
    }

    product: Product = {

        is_archive: false,
        type: '',
        nom: '',
        tva_id: 0,
        taxe_id: 0,
        taxes: [],
        prix_unitaires: 0,
        autoriser_vente_stock_vide : false,
        produit_avec_numero_serie : false,
        result_ht: 0,
        result_ttc: 0,
        image: undefined,
        marque_id: 0,
        categories_id: 0,
        unite_id: 0,
        ref_interne: '',
        ref_fabricant: undefined,
        code_barre: '',
        description: undefined,
        station_id: 0,
        client_id: 0,
        liste_prix: {
            prix_id: 0,
            bascul_calcul: '',
            regles: '',
            montant: 0,
            result_ttc: 0,
            result_ht: 0,
            client_id: 0,
            station_id: 0
        },
        informations_logistique: [
            {
                entrepot_id: 0,
                minimum: 0,
                maximum: 0,
                is_active_alert: false,
                client_id: 0,
                station_id: 0
            }
        ]
    };

    dataError: {
        type : string;
        logo: string;
        nom: string;
        tva: string;
        prix_unitaires: string;
        marge: string;
        prix_vente: string;
        list: string;
        montant: string;
        ref: string;
        refFabricant: string;
        codeBarre: string;
        bascul_calcul: string;
        regle: string;
        entrepot: string;
        min: string;
        max: string;
        priceBlockErrors: PriceBlockError[];
        warehouseBlockErrors: WarehouseBlockErrors[];

    } = {
        type :'',
        logo: '',
        nom: '',
        tva: '',
        prix_unitaires: '',
        marge: '',
        prix_vente: '',
        list: '',
        montant: '',
        ref: '',
        refFabricant: '',
        codeBarre: '',
        bascul_calcul: '',
        regle: '',
        entrepot : '',
        min : '',
        max : '',
        priceBlockErrors: [],
        warehouseBlockErrors : []
    };
    submitAttempted = false;

    mode: 'add' | 'edit';
    selectedMarqueId: number;
    priceLists = [
        {
            selectedPriceId: null,
            liste: null,
            prix_id: null,
            bascul_calcul: 'prix_public',
            regles: 'fixe',
            montant: null,
            result_ttc: 0,
            result_ht: 0,
            priceType: 'HT',
            saisie_type: 'HT',
        }
    ];
    warehouses = [
        {
            entrepot_id : null,
            minimum: null,
            maximum: null,
            is_active_alert: false
        }
    ];

    constructor(
        private headerService: HeaderService,
        private toastr: ToastrService,
        private cd: ChangeDetectorRef,
        private route: ActivatedRoute,
        private router: Router,
        private parametreService: ParametreService,
        private prixService: PrixService,
        private marqueService: MarqueService,
        private cdr: ChangeDetectorRef,
        private taxeService: TaxeService,
        private tvaService: TvaService,
        private categorieService: CategorieService,
        private uniteService: UniteService,
        private stationService: StationService,
        private productsService: ProductsService,
        private modalService: NgbModal,
        private ngZone: NgZone,
        private warehouseService: WarehouseService,
        private paramTablesService: ParamTablesService,
        private readonly paramDonneesState: ParametreDonneesStateService,
        @Inject(ERP_AFFICHAGES_API) private api: ErpAffichagesApi
    ) {
    }

    readonly paramTableTypeOptions: { value: AddProductParamType; label: string }[] = [
        { value: 'varchar', label: 'VARCHAR' },
        { value: 'date', label: 'Date' },
        { value: 'nombre', label: 'Nombre' },
        { value: 'select', label: 'Liste (select)' }
    ];

    readonly tableDbProducts = 'products';

    paramTableRows: AddProductParamRow[] = [];
    paramTablesLoading = false;
    /** Options par `param_table_id` pour les champs type liste (GET select-params). */
    private readonly paramSelectOptionsCache = new Map<number, AddProductSelectOption[]>();
    /** Étape « Paramètres des données » (ligne 3 champs dynamiques). */
    isStepParamDataValid = true;


    retour() {
        const productId =
            this.lastCreatedProductId ||
            this.lastUpdatedProductId ||
            this.productIdToEdit;

        if (this.mode === 'add') {
            this.router.navigate(['/produits-services']);
        } else if (this.mode === 'edit' && this.fromDetail) {
            this.router.navigate(['/bibliotheque-test/detail-produit', productId, 'vue-ensemble']);
        } else {
            this.router.navigate(['/produits-services']);
        }
    }

    preventNegativeInput(event: KeyboardEvent): boolean {
        // Prevent '-', 'e', 'E', '+'
        if (['-', 'e', 'E', '+'].includes(event.key)) {
            event.preventDefault();
            return false;
        }
        return true;
    }

    /** Empêche les flèches haut/bas de modifier la valeur (changement uniquement par saisie clavier). */
    preventNumberInputArrows(event: KeyboardEvent): void {
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
            event.preventDefault();
        }
    }

    ensurePositiveValue(warehouse: any, field: string): void {
        if (warehouse[field] < 0 || warehouse[field] === null || warehouse[field] === undefined) {
            warehouse[field] = 0;
        }
    }
    onPrixAchatChange() {
        if (this.product.prix_unitaires < 0) this.product.prix_unitaires = 0;

        // 1. CLEARING LOGIC: If Prix d'achat is cleared, clear the others
        if (this.product.prix_unitaires === null || this.product.prix_unitaires === undefined || this.product.prix_unitaires === 0) {
            this.margePourcentage = null;
            this.prixVente = null;
            this.calculateFinalPrice(); // Recalculate the final price (which will likely be 0 or null)
            return;
        }

        if (this.calculating) return;
        this.calculating = true;

        // 2. CALCULATION LOGIC: Only run if it makes sense (Prix d'achat is available)
        if (this.product.prix_unitaires !== null) {
            // Prioritize calculation from margin if available
            if (this.margePourcentage !== null) {
                this.calculateFromMarginPercentage(); // Calculates Prix Vente
            } else if (this.prixVente !== null) {
                this.calculateFromSellingPrice(); // Calculates Marge %
            }
        }

        this.calculating = false;
        this.calculateFinalPrice();
    }

    // NOUVELLE VERSION SIMPLIFIÉE
    onMargeChange() {
        if (this.margePourcentage < 0) this.margePourcentage = 0;

        if (this.calculating) return;
        this.calculating = true;

        // 1. Clearing Logic
        if (this.margePourcentage === null || this.margePourcentage === undefined) {
            this.prixVente = null;
        }
        // 2. FORWARD CALCULATION (Prix d'Achat + Marge -> Prix Vente) - SEUL CAS RESTANT
        else if (this.product.prix_unitaires !== null) {
            this.calculateFromMarginPercentage();
        }

        this.calculating = false;
        this.calculateFinalPrice();
    }

    // NOUVELLE VERSION SIMPLIFIÉE
    onPrixVenteChange() {
        if (this.prixVente < 0) this.prixVente = 0;

        if (this.calculating) return;
        this.calculating = true;

        // 1. Clearing Logic
        if (this.prixVente === null || this.prixVente === undefined) {
            this.margePourcentage = null;
        }
        // 2. FORWARD CALCULATION (Prix d'Achat + Prix Vente -> Marge %) - SEUL CAS RESTANT
        else if (this.product.prix_unitaires !== null) {
            this.calculateFromSellingPrice();
        }

        this.calculating = false;
        this.calculateFinalPrice();
    }


    calculateFromMarginPercentage() {
        // Calculates Prix Vente
        if (this.product.prix_unitaires !== null && this.margePourcentage !== null) {
            let prixVenteCalculated = this.product.prix_unitaires * (1 + this.margePourcentage / 100);

            // Appliquer 3 décimales et reconvertir en nombre
            this.prixVente = Number(prixVenteCalculated.toFixed(3));
        }
    }

    calculateFromSellingPrice() {
        // Calculates Marge %
        if (this.product.prix_unitaires !== null && this.prixVente !== null && this.product.prix_unitaires > 0) {
            let margeCalculated = ((this.prixVente - this.product.prix_unitaires) / this.product.prix_unitaires) * 100;

            // Appliquer 3 décimales et reconvertir en nombre
            this.margePourcentage = Number(margeCalculated.toFixed(3));
        } else {
            this.margePourcentage = 0;
        }
    }

    calculateFromMarginAndSellingPrice() {
        // Calculates Prix d'achat (P_achat = P_vente / (1 + Marge%/100))

        if (this.prixVente !== null && this.margePourcentage !== null) {
            // Ensure no division by zero or negative margin factor (since min="0" is set)
            const factor = 1 + this.margePourcentage / 100;

            if (factor > 0) {
                // Update the product's purchase price
                this.product.prix_unitaires = this.prixVente / factor;
                // Use Math.round or similar for proper financial precision if needed
            }
        }
    }

    validateMarginPercentage() {
        if (this.margePourcentage !== null && this.margePourcentage < 0) {
            this.dataError.marge = "La marge ne peut pas être négative";
        } else {
            this.dataError.marge = '';
        }
    }

    /*  priceHT = 0;
      priceTTC = 0;
      calculatePriceHT(): number {
          const prix = Number(this.product.prix_unitaires) || 0;
          const tvaObj = (this.tva || []).find(x => Number(x.id) === Number(this.product.tva_id));
          const tvaRate = tvaObj ? Number(tvaObj.valeur ?? 0) : 0;
          const taxeObj = (this.taxes || []).find(x => Number(x.id) === Number(this.product.taxe_id));
          const taxeRate = taxeObj ? Number(taxeObj.valeur ?? 0) : 0;
          const totalRate = (tvaRate + taxeRate) / 100;
          return +(prix / (1 + totalRate)).toFixed(2); // HT from TTC
      }

      calculatePriceTTC(): number {
          const prix = Number(this.product.prix_unitaires) || 0;
          const tvaObj = (this.tva || []).find(x => Number(x.id) === Number(this.product.tva_id));
          const tvaRate = tvaObj ? Number(tvaObj.valeur ?? 0) : 0;
          const taxeObj = (this.taxes || []).find(x => Number(x.id) === Number(this.product.taxe_id));
          const taxeRate = taxeObj ? Number(taxeObj.valeur ?? 0) : 0;
          const totalRate = (tvaRate + taxeRate) / 100;
          return +(prix * (1 + totalRate)).toFixed(2); // TTC from HT
      }

      calculateFinalPrice(): void {
          const prix = Number(this.product.prix_unitaires) || 0;

          const tvaObj = (this.tva || []).find(
              (x: any) => Number(x.id) === Number(this.product.tva_id)
          );
          const tvaRate = tvaObj ? Number(tvaObj.valeur) : 0;

          const taxeObj = (this.taxes || []).find(
              (x: any) => Number(x.id) === Number(this.product.taxe_id)
          );
          const taxeRate = taxeObj ? Number(taxeObj.valeur || 0) : 0;

          const totalRate = (tvaRate + taxeRate) / 100;

          // Calcul simultané HT ↔ TTC
          this.priceHT = +(prix / (1 + totalRate)).toFixed(2);
          this.priceTTC = +(prix * (1 + totalRate)).toFixed(2);
      }*/

    priceHT = 0;
    priceTTC = 0;
    public_ht = 0;
    public_ttc = 0;
    onPriceTypeChange(): void {
        this.calculateFinalPrice();
        this.recalculateAllPriceLists();
    }
    onTvaChange(): void {
        this.calculateFinalPrice();
        this.recalculateAllPriceLists();
    }
    calculatePublicPrices(): void {
        this.public_ht = this.product.result_ht;
        this.public_ttc = this.product.result_ttc;
    }

    calculateResults(i: number): void {
        const price = this.priceLists[i];

        if (!price.bascul_calcul || !price.montant) {
            return;
        }

        const montant = Number(price.montant);

        // Cas A: Base = "Prix public"
        if (price.bascul_calcul === 'prix_public') {
            if (price.regles === 'fixe') {
                // Règle = "Spécification fixe"
                price.result_ht = this.public_ht + montant;
                price.result_ttc = this.public_ttc + montant;
            } else if (price.regles === 'pourcentage') {
                // Règle = "Pourcentage"
                const pourcentageDecimal = montant / 100;
                price.result_ht = this.public_ht * (1 + pourcentageDecimal);
                price.result_ttc = this.public_ttc * (1 + pourcentageDecimal);
            }
        }
        // Cas B: Base = "Arbitraire"
        else if (price.bascul_calcul === 'arbitraires') {
            this.calculateArbitraryPrice(i);
        }

        // Formater les résultats
        price.result_ht = Number(price.result_ht.toFixed(2));
        price.result_ttc = Number(price.result_ttc.toFixed(2));
    }
    // Calcul pour le cas Arbitraire
    calculateArbitraryPrice(i: number): void {
        const price = this.priceLists[i];
        const tvaObj = (this.tva || []).find((x: any) => Number(x.id) === Number(this.product.tva_id));
        const tvaRate = tvaObj ? Number(tvaObj.valeur) : 0;

        const taxeObj = (this.taxes || []).find((x: any) => Number(x.id) === Number(this.product.taxe_id));
        const taxeRate = taxeObj ? Number(taxeObj.valeur || 0) : 0;

        const totalRate = (tvaRate + taxeRate) / 100;
        const montant = Number(price.montant) || 0;

        // Use individual priceType for each price list
        if (this.priceType2 === 'TTC') {
            // Si saisie en TTC
            price.result_ttc = montant;
            price.result_ht = +(montant / (1 + totalRate)).toFixed(2);
        } else {
            // Si saisie en HT
            price.result_ht = montant;
            price.result_ttc = +(montant * (1 + totalRate)).toFixed(2);
        }
    }
    onArbitraryPriceTypeChange(i: number): void {
        const price = this.priceLists[i];
        // Mettre à jour saisie_type en fonction de priceType individuel
        price.saisie_type = price.priceType;
        this.calculateResults(i); // Recalculer les résultats
    }


    /* onBaseCalculChange(i: number): void {
         const price = this.priceLists[i];

         if (price.bascul_calcul === 'arbitraires') {
             // Réinitialiser les règles pour arbitraire
             price.regles = null;
             price.montant = null;
             price.result_ht = 0;
             price.result_ttc = 0;
         } else {
             // Réinitialiser le montant pour prix public
             price.montant = null;
             price.result_ht = 0;
             price.result_ttc = 0;
         }
     }*/
    onBaseCalculChange(i: number): void {
        const price = this.priceLists[i];

        if (price.bascul_calcul === 'arbitraires') {
            // Réinitialiser les règles pour arbitraire
            price.regles = 'fixe';
            price.montant = null;
            price.result_ht = 0;
            price.result_ttc = 0;
            // Set default price type for arbitrary
            price.priceType = 'HT';
        } else {
            // Réinitialiser pour prix public
            price.montant = null;
            price.result_ht = 0;
            price.result_ttc = 0;
        }

        // Recalculate if there's any amount
        if (price.montant) {
            this.calculateResults(i);
        }
    }

    calculateFinalPrice(): void {
        const prix = Number(this.product.prix_unitaires) || 0;

        const tvaObj = (this.tva || []).find(
            (x: any) => Number(x.id) === Number(this.product.tva_id)
        );
        const tvaRate = tvaObj ? Number(tvaObj.valeur) : 0;

        const taxeObj = (this.taxes || []).find(
            (x: any) => Number(x.id) === Number(this.product.taxe_id)
        );
        const taxeRate = taxeObj ? Number(taxeObj.valeur || 0) : 0;

        const totalRate = (tvaRate + taxeRate) / 100;

        if (this.priceType === 'HT') {
            this.product.result_ht = prix;
            this.product.result_ttc = +(prix * (1 + totalRate)).toFixed(2);
        } else {
            this.product.result_ttc = prix;
            this.product.result_ht = +(prix / (1 + totalRate)).toFixed(2);
        }

        // Mettre à jour les prix publics
        this.calculatePublicPrices();
        // Mettre à jour les montants Résultat (HT/TTC) des listes de prix basées sur le prix public
        this.recalculateAllPriceLists();
    }


    recalculateAllPriceLists(): void {
        this.priceLists.forEach((price, index) => {
            if (price.bascul_calcul && price.montant) {
                this.calculateResults(index);
            }
        });
    }
    fromDetail = false;
    onMinusClick(i: number, price: any) {
        const hasSelection = price.selectedPriceId || price.montant;
        const onlyOne = this.priceLists.length === 1;

        if (onlyOne && hasSelection) {
            this.clearPriceListSelection(i);
        } else {
            this.removePriceList(i);
        }
    }
    onWarehouseMinusClick(i: number, warehouse: any) {
        const hasSelection = warehouse.entrepot_id || warehouse.minimum || warehouse.maximum;
        const onlyOne = this.warehouses.length === 1;

        if (onlyOne && hasSelection) {
            this.clearWarehouseListSelection(i);
        } else {
            this.removeWarehouse(i);
        }
    }


    ngOnInit(): void {
        this.calculateFinalPrice(); // Calcul initial
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.currentRoute = event.urlAfterRedirects;
                //   this.updatePageFromRoute();
                const el = this.contentWrapper?.nativeElement;
                if (el) {
                    el.classList.remove('animate__fadeIn');
                    void el.offsetWidth;
                    el.classList.add('animate__fadeIn');
                }
            });
        this.getAllEntrepots();
        this.tvaService.messageEmitter.subscribe((msg) => {
            this.messageRecu = msg;
        });
        this.fromDetail = history.state.fromDetail || false;
        this.headerService.setConfig({
            title: 'Produits & Services',
            buttons: []
        });

        this.initializeComponent();
        this.setupModalSubscription();
        //    this.setupModalSubscription();
    }

    private setupModalSubscription(): void {
        this.subscriptions.add(
            this.parametreService.openModal$.pipe(debounceTime(100)).subscribe(({component, action, subType}) => {
                //console.log('Modal subscription triggered:', {component, action, subType});
                if (component === 'taxe-tva' && action === 'add') {
                    // Use the subType passed from addtax() method, don't fall back to activeTab
                    this.openModal('ajouter', undefined, undefined, subType);
                }
            })
        );
    }

    private initializeComponent(): void {
        // Check if we're in edit mode
        const productId = this.route.snapshot.paramMap.get('id');
        this.editMode = !!productId;

        if (this.editMode) {
            this.productIdToEdit = +productId; // Convert to number
        }

        // Set mode based on edit mode
        this.mode = this.editMode ? 'edit' : 'add';

        // Handle step parameter for edit mode
        this.handleEditModeSteps();

        // Load initial data
        this.loadInitialData();
    }

    private handleEditModeSteps(): void {
        if (this.editMode) {
            // Get the step from query params, default to step 1 for edit mode
            this.route.queryParams.subscribe(params => {
                const stepParam = params['step'];
                if (stepParam) {
                    this.currentStep = parseInt(stepParam, 10);
                } else {
                    // Default to step 1 for edit mode (skip product type selection)
                    this.currentStep = 1;
                }

                // Load product data if in edit mode
                this.loadProductForEdit();
            });
        } else {
            // Add mode: start from step 0
            this.currentStep = 0;
        }
    }

    private loadProductForEdit(): void {
        if (!this.productIdToEdit) return;

        this.isLoading = true;
        this.productsService.getDetailsProduct(this.productIdToEdit).subscribe({
            next: (product) => {
                product.autoriser_vente_stock_vide = !!product.autoriser_vente_stock_vide;
                product.produit_avec_numero_serie = !!product.produit_avec_numero_serie;
               // console.log('Product loaded for edit:', product);
                this.populateFormWithProductData(product);
                this.isLoading = false;
                this.cd.detectChanges();
                this.refreshFeatherIcons();
            },
            error: (err) => {
                this.toastr.error('Erreur lors du chargement du produit');
                this.isLoading = false;
                this.cd.detectChanges();
            }
        });
    }

    private populateFormWithProductData(product: any): void {
        // Set product type
        this.productType = product.type;
        this.product.type = product.type;

        // Populate taxes - ensure it's always an array
        // The API returns taxes with 'taxes_id' as the real taxe ID (not 'id' which is the pivot ID)
        let productTaxes: any[] = [];
        if (Array.isArray(product.taxes) && product.taxes.length > 0) {
            // Map the taxes to ensure they have the correct structure
            // Use 'taxes_id' as 'id' to match with the taxes list
            productTaxes = product.taxes.map((taxe: any) => {
                // The API uses 'taxes_id' for the actual taxe ID
                if (taxe.taxes_id) {
                    return {
                        ...taxe,
                        id: taxe.taxes_id  // Map taxes_id to id for consistency
                    };
                }
                // Fallback: if taxe has 'taxe_id', use it
                if (taxe.taxe_id) {
                    return {
                        ...taxe,
                        id: taxe.taxe_id
                    };
                }
                // If taxe already has 'id' and no taxes_id, use it as is
                return taxe;
            });
        }

        // Populate basic product information (dont result_ht / result_ttc pour recalcul ou valeur API)
        this.product = {
            ...this.product,
            nom: product.nom || '',
            tva_id: product.tva_id || '',
            taxes: productTaxes,
            prix_unitaires: product.prix_unitaires || 0,
            result_ht: product.result_ht != null ? Number(product.result_ht) : this.product.result_ht,
            result_ttc: product.result_ttc != null ? Number(product.result_ttc) : this.product.result_ttc,
            image: product.image || '',
            marque_id: product.marque_id || '',
            categories_id: product.categories_id || '',
            unite_id: product.unite_id || '',
            ref_interne: product.ref_interne || '',
            ref_fabricant: product.ref_fabricant || '',
            code_barre: product.code_barre ?? '',
            description: product.description || '',
            autoriser_vente_stock_vide : product.autoriser_vente_stock_vide,
            produit_avec_numero_serie : !!product.produit_avec_numero_serie

        };

        // Set logo preview if image exists
        if (product.image) {
            this.logoPreview = product.image;
        }

        // Populate price lists if available
        if (product.liste_prix && product.liste_prix.length > 0) {
            this.priceLists = product.liste_prix.map((price: any) => ({
                selectedPriceId: price.prix_id,
                prix_id: price.prix_id,
                bascul_calcul: price.bascul_calcul || 'prix_public',
                regles: price.regles,
                montant: price.montant || 0,
                result_ttc: price.result_ttc || 0,
                result_ht: price.result_ht || 0
            }));
        }

        // Populate warehouses if available and product is material
        if (product.type === 'matériel' && product.informations_logistique && product.informations_logistique.length > 0) {
            this.warehouses = product.informations_logistique.map((wh: any) => ({
                entrepot_id: wh.entrepot_id ,
                minimum: wh.minimum || 0,
                maximum: wh.maximum || 0,
                is_active_alert: wh.is_active_alert || false
            }));
        }

        // Recalculer result_ht / result_ttc (à partir de prix_unitaires + TVA/taxes si pas fournis par l’API)
        const hasResultFromApi = (this.product.result_ht != null && this.product.result_ht !== 0) ||
            (this.product.result_ttc != null && this.product.result_ttc !== 0);
        if (!hasResultFromApi) {
            this.calculateFinalPrice();
        } else {
            this.calculatePublicPrices();
        }
        this.recalculateAllPriceLists();

        // Validate steps since we're populating data
        this.validateStep1();
        this.validateStep2();
        this.validateStep3();
    }

    loadInitialData(): void {
        this.loadPrix();
        this.loadMarques();
        this.loadCategories();
        this.loadUnites();
        this.loadTVA();
        this.loadTaxe();
        this.cd.detectChanges();
    }

    onTimelineGoBack(): void {
        this.goBack();
    }

    onTimelineStepSelected(stepIndex: number): void {
        if (stepIndex >= 0 && stepIndex < this.steps.length && this.isPreviousStepsValid(stepIndex)) {
            this.currentStep = stepIndex;
            if (stepIndex === 3) {
                this.loadProductParamTables();
            }
            this.cd.detectChanges();
            this.refreshFeatherIcons();
        }
    }

    nextStep(): void {
        if (this.isCurrentStepValid() && this.currentStep < this.steps.length - 1) {
            this.currentStep++;
            if (this.currentStep === 3) {
                this.loadProductParamTables();
            }
            this.cd.detectChanges();
            this.refreshFeatherIcons();
        }
    }

    loadProductParamTables(): void {
        const sid = Number(this.stationId);
        const uid = Number(this.clientId);
        if (!Number.isFinite(sid) || sid <= 0 || !Number.isFinite(uid) || uid <= 0) {
            this.toastr.warning('Station ou utilisateur introuvable pour charger les paramètres.', 'Attention');
            this.paramTableRows = [this.createEmptyParamRow(0)];
            return;
        }
        this.paramSelectOptionsCache.clear();
        this.paramTablesLoading = true;
        this.paramDonneesState.ensureRefModules().pipe(
            map(() => {
                const ref =
                    this.paramDonneesState.getModuleRef(this.tableDbProducts) ??
                    this.paramDonneesState.getModuleRef('produits');
                const tableDbId = ref ? resolveRefModuleTableDbId(ref) : NaN;
                // Priorité à l'id table (nouvelle API). Fallback sur l'ancien segment "products" si non résolu.
                return Number.isFinite(tableDbId) && tableDbId > 0 ? tableDbId : this.tableDbProducts;
            }),
            switchMap((tableDbOrId) => this.paramTablesService.getParamTablesByTable(tableDbOrId, sid, uid)),
            switchMap((raw) => {
                let rows = this.normalizeParamTableResponse(raw);
                if (rows.length === 0) {
                    rows = [this.createEmptyParamRow(0)];
                }
                const productId = this.resolveProductIdForCoordinateValeur();
                return this.applyCoordinateValeursFromApi$(rows, sid, uid, productId).pipe(
                    map((withVals) => (withVals.length === 0 ? [this.createEmptyParamRow(0)] : withVals)),
                    switchMap((finalRows) => this.loadSelectParamOptionsForRows$(finalRows, sid, uid))
                );
            }),
            finalize(() => {
                this.paramTablesLoading = false;
                this.cd.detectChanges();
            })
        ).subscribe({
            next: (rows) => {
                this.paramTableRows = rows;
                this.validateParamStep();
            },
            error: () => {
                this.toastr.error('Impossible de charger les paramètres des données.');
                this.paramTableRows = [this.createEmptyParamRow(0)];
            }
        });
    }

    /** Produit courant pour lire les valeurs coordinate-params (édition / produit déjà créé). */
    private resolveProductIdForCoordinateValeur(): number | null {
        if (this.productIdToEdit != null && Number.isFinite(this.productIdToEdit) && this.productIdToEdit > 0) {
            return Math.floor(this.productIdToEdit);
        }
        const pid = this.product?.id;
        if (pid != null && Number.isFinite(Number(pid)) && Number(pid) > 0) {
            return Math.floor(Number(pid));
        }
        if (this.lastCreatedProductId != null && this.lastCreatedProductId > 0) {
            return this.lastCreatedProductId;
        }
        return null;
    }

    /**
     * Remplit `valeur` via GET coordinate-params/by-param-table/:param_table_id/product/:product_id (ids du GET param-tables + produit courant).
     */
    private applyCoordinateValeursFromApi$(
        rows: AddProductParamRow[],
        stationId: number,
        userId: number,
        productId: number | null
    ): Observable<AddProductParamRow[]> {
        const tableIds = [
            ...new Set(
                rows
                    .map((r) => r.param_table_id)
                    .filter((id): id is number => id != null && id > 0)
            )
        ];
        if (tableIds.length === 0 || productId == null || productId <= 0) {
            return of(rows);
        }
        return forkJoin(
            tableIds.map((ptid) =>
                this.paramTablesService
                    .getCoordinateParamsByParamTableProduct(ptid, productId, stationId, userId)
                    .pipe(catchError(() => of(null)))
            )
        ).pipe(
            map((responses) => {
                const byParamTableId = new Map<number, string>();
                tableIds.forEach((ptid, idx) => {
                    const raw = responses[idx];
                    byParamTableId.set(ptid, this.parseCoordinateValeurResponse(raw, productId));
                });
                return rows.map((r) => {
                    if (r.param_table_id == null || r.param_table_id <= 0) {
                        return r;
                    }
                    const v = byParamTableId.get(r.param_table_id);
                    return v !== undefined ? { ...r, valeur: v } : r;
                });
            })
        );
    }

    /** Interprète la réponse API (objet unique, { data }, liste filtrée par product_id). */
    private parseCoordinateValeurResponse(raw: unknown, productId: number): string {
        if (raw == null) {
            return '';
        }
        const anyRaw = raw as Record<string, unknown>;
        const direct = anyRaw['valeur'] ?? anyRaw['value'];
        if (typeof direct === 'string' || typeof direct === 'number') {
            return String(direct);
        }
        const data = anyRaw['data'];
        const list: unknown[] = Array.isArray(data)
            ? data
            : Array.isArray(anyRaw['rows'])
              ? (anyRaw['rows'] as unknown[])
              : Array.isArray(raw)
                ? (raw as unknown[])
                : [];
        if (list.length > 0) {
            const forProduct = list.find(
                (item) =>
                    item &&
                    typeof item === 'object' &&
                    Number((item as Record<string, unknown>)['product_id']) === productId
            ) as Record<string, unknown> | undefined;
            const pick = forProduct ?? (list[0] as Record<string, unknown>);
            const v = pick?.['valeur'] ?? pick?.['value'];
            if (v != null) {
                return String(v);
            }
        }
        return '';
    }

    /** Options ng-select pour une ligne paramètre type liste. */
    getParamSelectOptions(paramTableId: number | null | undefined): AddProductSelectOption[] {
        if (paramTableId == null || !Number.isFinite(Number(paramTableId)) || Number(paramTableId) <= 0) {
            return [];
        }
        return this.paramSelectOptionsCache.get(Math.floor(Number(paramTableId))) ?? [];
    }

    /**
     * Charge les libellés / valeurs pour chaque `param_table_id` concerné (GET select-params/param-table/:id).
     */
    private loadSelectParamOptionsForRows$(
        rows: AddProductParamRow[],
        stationId: number,
        userId: number
    ): Observable<AddProductParamRow[]> {
        const ids = [
            ...new Set(
                rows
                    .filter((r) => r.type === 'select' && r.param_table_id != null && r.param_table_id > 0)
                    .map((r) => Math.floor(r.param_table_id as number))
            )
        ];
        if (ids.length === 0) {
            return of(rows);
        }
        return forkJoin(
            ids.map((ptid) =>
                this.paramTablesService.getSelectParamsByParamTable(ptid, stationId, userId).pipe(
                    map((raw) => ({ ptid, opts: this.parseSelectParamsResponse(raw) })),
                    catchError(() => of({ ptid, opts: [] as AddProductSelectOption[] }))
                )
            )
        ).pipe(
            tap((pairs) => {
                pairs.forEach(({ ptid, opts }) => this.paramSelectOptionsCache.set(ptid, opts));
            }),
            map(() => rows)
        );
    }

    private parseSelectParamsResponse(raw: unknown): AddProductSelectOption[] {
        const list = this.unwrapSelectParamsList(raw);
        const out: AddProductSelectOption[] = [];
        for (const item of list) {
            if (!item || typeof item !== 'object') {
                continue;
            }
            const o = item as Record<string, unknown>;
            const lib = String(o['libelle'] ?? o['label'] ?? o['nom'] ?? '').trim();
            const valueRaw = o['value'] ?? o['valeur'] ?? o['code'] ?? o['id'] ?? o['select_param_id'];
            const val = valueRaw != null && valueRaw !== '' ? String(valueRaw).trim() : '';
            const label = lib || val;
            const value = val || lib;
            if (label === '' && value === '') {
                continue;
            }
            out.push({ label: label || value, value: value || label });
        }
        return out;
    }

    private unwrapSelectParamsList(raw: unknown): unknown[] {
        if (Array.isArray(raw)) {
            return raw;
        }
        if (raw && typeof raw === 'object') {
            const o = raw as Record<string, unknown>;
            const cand =
                o['data'] ??
                o['rows'] ??
                o['items'] ??
                o['options'] ??
                o['select_params'] ??
                o['results'];
            if (Array.isArray(cand)) {
                return cand;
            }
            if (cand && typeof cand === 'object' && !Array.isArray(cand)) {
                const inner = (cand as Record<string, unknown>)['rows'] ?? (cand as Record<string, unknown>)['data'];
                if (Array.isArray(inner)) {
                    return inner;
                }
            }
        }
        return [];
    }

    private createEmptyParamRow(index: number): AddProductParamRow {
        return {
            libelle: '',
            type: 'varchar',
            valeur: '',
            champ_db: `param${index + 1}`,
            param_table_id: null
        };
    }

    /** Adapte plusieurs formes de réponse API possibles. */
    private normalizeParamTableResponse(raw: unknown): AddProductParamRow[] {
        const anyRaw = raw as Record<string, unknown> | unknown[] | null | undefined;
        let list: unknown[] = [];
        if (Array.isArray(anyRaw)) {
            list = anyRaw;
        } else if (anyRaw && typeof anyRaw === 'object') {
            const o = anyRaw as Record<string, unknown>;
            const cand =
                o['data'] ??
                o['rows'] ??
                o['param_tables'] ??
                o['parametrage'] ??
                o['items'];
            list = Array.isArray(cand) ? cand : [];
        }
        const rows: AddProductParamRow[] = [];
        for (let i = 0; i < list.length; i++) {
            const row = list[i] as Record<string, unknown>;
            if (!row || typeof row !== 'object') {
                continue;
            }
            const lib =
                (row['libelle_champ'] ?? row['libelle'] ?? row['label'] ?? '') as string;
            /* type : uniquement depuis GET param-tables/by-table/products (plusieurs clés possibles côté API) */
            const typeRaw = (row['type'] ??
                row['type_champ'] ??
                row['champ_type'] ??
                row['param_type'] ??
                row['data_type'] ??
                'varchar') as string;
            const typeNorm = this.normalizeParamType(typeRaw);
            /* valeur : chargée via GET .../by-param-table/:id/product/:product_id?station_id&user_id */
            const champ =
                (row['champ_db'] ?? row['champDb'] ?? `param${i + 1}`) as string;
            const rawPid =
                row['id'] ?? row['param_table_id'] ?? row['paramTableId'] ?? row['parametrage_table_id'];
            let param_table_id: number | null = null;
            if (rawPid != null && rawPid !== '') {
                const n = Number(rawPid);
                if (Number.isFinite(n) && n > 0) {
                    param_table_id = Math.floor(n);
                }
            }
            rows.push({
                libelle: lib != null ? String(lib) : '',
                type: typeNorm,
                valeur: '',
                champ_db: champ != null ? String(champ) : `param${i + 1}`,
                param_table_id
            });
        }
        return rows;
    }

    private normalizeParamType(t: string): AddProductParamType {
        const s = (t || '').toLowerCase().trim();
        if (s === 'date' || s === 'datetime') {
            return 'date';
        }
        if (
            s === 'nombre' ||
            s === 'number' ||
            s === 'double' ||
            s === 'numeric' ||
            s === 'int' ||
            s === 'integer' ||
            s === 'float' ||
            s === 'decimal'
        ) {
            return 'nombre';
        }
        if (s === 'select' || s === 'liste' || s === 'dropdown' || s === 'list') {
            return 'select';
        }
        if (s === 'varchar' || s === 'text' || s === 'string' || s === 'char') {
            return 'varchar';
        }
        return 'varchar';
    }

    validateParamStep(): void {
        this.isStepParamDataValid = true;
    }

    /** Flatpickr pour les champs « Date » (paramètres produit) : FR, affichage jj/mm/aaaa, valeur API yyyy-MM-dd. */
    readonly paramDateFlatpickrOptions: FlatpickrOptions = {
        locale: French,
        altInput: true,
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d',
        allowInput: true,
        disableMobile: true,
        monthSelectorType: 'dropdown',
        altInputClass: 'form-control add-product-param-date-alt',
        onReady: (_selectedDates, _dateStr, instance) => {
            instance.calendarContainer.classList.add('add-product-param-fp-cal');
        }
    };


    /**
     * Valeur pour input natif type="date" (yyyy-MM-dd).
     * Accepte une date déjà ISO courte ou une chaîne parseable par Date.
     */
    /** yyyy-MM-dd en date locale (évite le décalage UTC de toISOString). */
    private formatLocalDateYmd(d: Date): string {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${y}-${m}-${day}`;
    }

    toParamDateInputValue(v: string | null | undefined): string {
        if (v == null || String(v).trim() === '') {
            return '';
        }
        const t = String(v).trim();
        if (/^\d{4}-\d{2}-\d{2}$/.test(t)) {
            return t;
        }
        const d = new Date(t);
        if (!Number.isNaN(d.getTime())) {
            return d.toISOString().slice(0, 10);
        }
        return '';
    }

    onParamDateValeurChange(row: AddProductParamRow, value: unknown): void {
        if (value == null || value === '') {
            row.valeur = '';
            return;
        }
        if (Array.isArray(value) && value[0] instanceof Date) {
            row.valeur = this.formatLocalDateYmd(value[0]);
            return;
        }
        if (value instanceof Date) {
            row.valeur = this.formatLocalDateYmd(value);
            return;
        }
        const s = String(value).trim();
        row.valeur = s === '' ? '' : this.toParamDateInputValue(s);
    }

    /** POST coordinate-params : lignes avec `param_table_id` (GET) et `valeur` renseignée. */
    private buildCoordinateParamsPayloads(productId: number): CoordinateParamsPayload[] {
        const sid = Number(this.stationId);
        const uid = Number(this.clientId);
        if (!Number.isFinite(sid) || sid <= 0 || !Number.isFinite(uid) || uid <= 0) {
            return [];
        }
        if (!Number.isFinite(productId) || productId <= 0) {
            return [];
        }
        const out: CoordinateParamsPayload[] = [];
        for (const row of this.paramTableRows) {
            const ptid = row.param_table_id;
            if (ptid == null || ptid <= 0) {
                continue;
            }
            const v = (row.valeur ?? '').trim();
            if (v === '') {
                continue;
            }
            out.push({
                station_id: Math.floor(sid),
                user_id: Math.floor(uid),
                param_table_id: Math.floor(ptid),
                product_id: Math.floor(productId),
                valeur: v
            });
        }
        return out;
    }

    private saveCoordinateParams$(productId: number): Observable<unknown | unknown[] | null> {
        const payloads = this.buildCoordinateParamsPayloads(productId);
        if (payloads.length === 0) {
            return of(null);
        }
        return this.paramTablesService.postCoordinateParams(payloads);
    }

    /** Tous les ids produit après PUT (famille = plusieurs). */
    private extractProductIdsAfterUpdate(response: unknown): number[] {
        const r = response as { product?: { id?: number } } | unknown[] | null | undefined;
        if (Array.isArray(r)) {
            const ids: number[] = [];
            for (const item of r) {
                const id = (item as { product?: { id?: number } })?.product?.id;
                if (id != null && Number.isFinite(Number(id))) {
                    ids.push(Math.floor(Number(id)));
                }
            }
            return ids.length ? ids : (this.productIdToEdit ? [this.productIdToEdit] : []);
        }
        const id = (r as { product?: { id?: number } })?.product?.id ?? this.productIdToEdit;
        if (id == null || !Number.isFinite(Number(id))) {
            return [];
        }
        return [Math.floor(Number(id))];
    }

    goBack(): void {
        if (this.editMode) {
            // In edit mode, we don't go back to step 0 (product type selection)
            if (this.currentStep > 1) {
                this.currentStep--;
            } else {
                // If we're at step 1 and go back, navigate to products list
                this.router.navigate(['/produits-services']);
            }
        } else {
            // Add mode behavior
            if (this.currentStep > 0) {
                this.currentStep--;
            }
        }
        this.cd.detectChanges();
        this.refreshFeatherIcons();
    }

    isPreviousStepsValid(stepIndex: number): boolean {
        for (let i = 0; i < stepIndex; i++) {
            switch (i) {
                case 0:
                    if (!this.isStep1Valid) return false;
                    break;
                case 1:
                    if (!this.isStep2Valid) return false;
                    break;
                case 2:
                    if (!this.isStep3Valid) return false;
                    break;
                case 3:
                    if (!this.isStepParamDataValid) return false;
                    break;
            }
        }
        return true;
    }

    isCurrentStepValid(): boolean {
        switch (this.currentStep) {
            case 0:
                return this.isStep1Valid;
            case 1:
                return this.isStep2Valid;
            case 2:
                return this.isStep3Valid;
            case 3:
                return this.isStepParamDataValid;
            case 4:
                return true;
            default:
                return false;
        }
    }

    validateStep1(): void {

        if (this.editMode) { // In edit mode, step 1 is always valid since we skip product type selection

            this.isStep1Valid = true;
        } else {
            this.dataError.type = '';
            this.submitAttemptedStep1 = true;
            this.isStep1Valid = !!this.product.type;
        }
        if (this.isStep1Valid) {
            this.submitAttemptedStep1 = false;
        }
    }

    handleStep1Continue() {
        let hasError = false;
        if (!this.product.type) {
            this.dataError.type = "Le type de produit est obligatoire";
            hasError = true;
        }

        this.handleStepCompletion(0);
    }

    validateStep2(): void {

        this.isStep2Valid = !!this.product.nom && !!this.product.prix_unitaires;

    }

    validateStep3(): void {

        this.isStep3Valid = true;
    }

    selectedFile: File | null = null;

    onFileSelected(event: any): void {
        const file = (event.target as HTMLInputElement).files?.[0];
        this.dataError.logo = '';
        // IMPORTANT: Reset selectedFile to ensure only the latest is kept
        this.selectedFile = null;
        this.logoPreview = ''; // Reset preview as well

        if (file) {
            if (file.size > 1024 * 1024) {
                this.dataError.logo = 'Le fichier ne doit pas dépasser 1 Mo.';
                return;
            }

            // **1. Store the File (DO NOT UPLOAD HERE)**
            this.selectedFile = file;

            // 2. Create the preview for the user
            const reader = new FileReader();
            reader.onload = () => {
                this.logoPreview = reader.result as string;
            };
            reader.readAsDataURL(file);

            // 3. Optional: Clear the image property on the product object
            // until the file is successfully uploaded/saved.
            // this.product.image = '';
        }
    }

    handleStepCompletion(stepIndex: number): void {
        if (this.editMode) {
            this.handleEditStepCompletion(stepIndex);
        } else {
            this.handleAddStepCompletion(stepIndex);
        }
    }

    clearFieldError(fieldName: string): void {
        if (this.dataError[fieldName]) {
            this.dataError[fieldName] = '';
        }
    }


    private handleAddStepCompletion(stepIndex: number): void {
        this.dataError = {
            type :'',
            logo: '',
            nom: '',
            tva: '',
            prix_unitaires: '',
            marge: '',
            prix_vente: '',
            list: '',
            montant: '',
            ref: '',
            refFabricant: '',
            codeBarre: '',
            bascul_calcul: '',
            regle: '',
            entrepot : '',
            min : '',
            max : '',
            priceBlockErrors: [],
            warehouseBlockErrors : []
        }
        let hasError = false;
        if (stepIndex === 0) {
            if (!this.product.type) {
                this.dataError.type = "Le type de produit est obligatoire";
                hasError = true;
            }
            if (hasError) {
                /*  this.toastr.error('Veuillez remplir les champs obligatoires dans le formulaire.', 'Attention', {
                      positionClass: 'toast-bottom-right',

                  });*/
                this.submitAttempted = true;
                return;
            }
            this.validateStep1();
            if (this.isStep1Valid) {
                this.nextStep();
            }
        }
        else if (stepIndex === 1) {

            if (!this.product.nom || !this.product.nom.trim()) {
                this.dataError.nom = "Le nom du produit est obligatoire";
                hasError = true;
            }

            if (!this.product.tva_id) {
                this.dataError.tva = "Le TVA est obligatoire";
                hasError = true;
            }

            if (!this.product.prix_unitaires) {
                this.dataError.prix_unitaires = "Le prix unitaire est obligatoire";
                hasError = true;
            }
            if (!this.product.prix_unitaires) {
                this.dataError.prix_vente = "Le prix vente est obligatoire";
                hasError = true;
            }
            if (!this.product.prix_unitaires) {
                this.dataError.marge = "Le marge est obligatoire";
                hasError = true;
            }
            if (this.priceLists && this.priceLists.length > 0) {
                for (let i = 0; i < this.priceLists.length; i++) {
                    const price = this.priceLists[i];
                    if (price.selectedPriceId) {
                        if (price.montant === null || price.montant === undefined || price.montant === '') {
                            this.dataError.montant = `Le montant est obligatoire `;
                            hasError = true;
                        }
                        if (price.bascul_calcul === null) {
                            this.dataError.bascul_calcul = `Le choix est obligatoire `;
                            hasError = true;

                        }
                        if (price.regles === null) {
                            this.dataError.regle = `Le choix est obligatoire `;
                            hasError = true;
                            break;
                        }
                        if (!this.dataError.priceBlockErrors[i]) {
                            this.dataError.priceBlockErrors[i] = {bascul_calcul: '', regles: ''};
                        }

                    }
                    if (price.montant == 0 || price.montant !== null) {

                        if (price.bascul_calcul === null) {
                            this.dataError.bascul_calcul = `Le choix est obligatoire `;
                            hasError = true;

                        }
                        if (price.regles === null) {
                            this.dataError.regle = `Le choix est obligatoire `;
                            hasError = true;

                        }
                        if (price.selectedPriceId === null) {
                            this.dataError.list = `Le type de prix est obligatoire `;
                            hasError = true;
                            break;
                        }
                    }
                    if (price.montant == 0) {
                        price.montant = null;
                    }
                }
            }

            if (this.warehouses && this.warehouses.length > 0) {
                for (let i = 0; i < this.warehouses.length; i++) {
                    const warehouse = this.warehouses[i];
                    if (warehouse.entrepot_id) {
                        if (warehouse.minimum === null || warehouse.minimum === undefined || warehouse.minimum === '') {
                            this.dataError.min = `La quantité minimale est obligatoire `;
                            hasError = true;
                        }
                        if (warehouse.maximum === null || warehouse.maximum === undefined || warehouse.maximum === '') {
                            this.dataError.max = `La quantité maximale est obligatoire `;
                            hasError = true;
                        }

                    }
                    if (warehouse.minimum == 0 || warehouse.minimum !== null) {

                        if (warehouse.maximum === null) {
                            this.dataError.max = `La quantité maximale est obligatoire `;
                            hasError = true;

                        }
                        if (warehouse.entrepot_id === null) {
                            this.dataError.entrepot = `Le dépôt est obligatoire `;
                            hasError = true;
                            break;
                        }
                    }
                    if (warehouse.maximum == 0 || warehouse.maximum !== null) {

                        if (warehouse.minimum === null) {
                            this.dataError.min = `La quantité minimale est obligatoire `;
                            hasError = true;

                        }
                        if (warehouse.entrepot_id === null) {
                            this.dataError.entrepot = `Le dépôt est obligatoire `;
                            hasError = true;
                            break;
                        }
                    }

                }
            }

            if (hasError) {

                this.scrollToTop();
                this.submitAttempted = true;
                return;
            }
            this.validateStep2();
            if (this.isStep2Valid) {
                this.nextStep();
            }
        } else if (stepIndex === 2) {
            // Add validation for reference field in step 3
            let hasError = false;
            if (!this.product.ref_interne || !this.product.ref_interne.trim()) {
                this.dataError.ref = "La référence du produit est obligatoire !";
                hasError = true;
            }

            const refFab = this.product.ref_fabricant != null ? String(this.product.ref_fabricant).trim() : '';
            if (!refFab) {
                this.dataError.refFabricant = 'La référence fabricant est obligatoire.';
                hasError = true;
            }
            if (this.shouldShowCodeBarreInput()) {
                const codeBar = this.product.code_barre != null ? String(this.product.code_barre).trim() : '';
                if (!codeBar) {
                    this.dataError.codeBarre = 'Le code-barres est obligatoire.';
                    hasError = true;
                }
            }

            if (hasError) {
                /*   this.toastr.error('La référence du produit est obligatoire.', 'Attention', {
                       positionClass: 'toast-bottom-right',
                   });*/
                this.scrollToTop();
                this.submitAttempted = true;
                return;
            }

            this.validateStep3();
            if (this.isStep3Valid) {
                this.validateParamStep();
                this.nextStep();
            }
        } else if (stepIndex === 3) {
            this.validateParamStep();
            if (this.isStepParamDataValid) {
                this.saveProduct();
            }
        }
    }
    scrollToTop() {
        // Try scrolling the window first
        window.scrollTo({ top: 0, behavior: 'smooth' });

        // Also try scrolling the main content container if it exists
        const container = document.querySelector('.step-form') || document.querySelector('.main-content') || document.body;
        container.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    setPriceBlockError(index: number, field: string, message: string) {
        if (!this.dataError.priceBlockErrors[index]) {
            this.dataError.priceBlockErrors[index] = {bascul_calcul: '', regles: ''};
        }
        this.dataError.priceBlockErrors[index][field] = message;
    }

    getPriceBlockError(index: number, field: string): string {
        return this.dataError.priceBlockErrors[index]?.[field] || '';
    }

    /**
     * Mise à jour rapide (édition) : valide les champs obligatoires des étapes 1+2,
     * puis lance `updateProduct()` et bascule vers l’étape "Terminé".
     */
    quickUpdate(): void {
        if (!this.editMode) {
            return;
        }

        // Réinitialiser les erreurs (même structure que les autres flows)
        this.dataError = {
            type: '',
            logo: '',
            nom: '',
            tva: '',
            prix_unitaires: '',
            marge: '',
            prix_vente: '',
            list: '',
            montant: '',
            ref: '',
            refFabricant: '',
            codeBarre: '',
            bascul_calcul: '',
            regle: '',
            entrepot: '',
            min: '',
            max: '',
            priceBlockErrors: [],
            warehouseBlockErrors: []
        };

        let hasError = false;

        // --- validations étape 1 (currentStep === 1) ---
        if (!this.product.nom || !this.product.nom.trim()) {
            this.dataError.nom = 'Le nom du produit est obligatoire';
            hasError = true;
        }
        if (!this.product.tva_id) {
            this.dataError.tva = 'Le TVA est obligatoire';
            hasError = true;
        }
        if (!this.product.prix_unitaires && this.product.prix_unitaires !== 0) {
            this.dataError.prix_unitaires = 'Le prix unitaire est obligatoire';
            hasError = true;
        }

        // Listes de prix
        if (this.priceLists && this.priceLists.length > 0) {
            for (let i = 0; i < this.priceLists.length; i++) {
                const price = this.priceLists[i];

                if (price.selectedPriceId) {
                    if (price.montant === null || price.montant === undefined || price.montant === '') {
                        this.dataError.montant = 'Le montant est obligatoire ';
                        hasError = true;
                    }
                    if (price.bascul_calcul === null || price.bascul_calcul === undefined) {
                        this.dataError.bascul_calcul = 'Le choix est obligatoire ';
                        hasError = true;
                    }
                    if (price.regles === null || price.regles === undefined) {
                        this.dataError.regle = 'Le choix est obligatoire ';
                        hasError = true;
                        break;
                    }
                    if (!this.dataError.priceBlockErrors[i]) {
                        this.dataError.priceBlockErrors[i] = { bascul_calcul: '', regles: '' };
                    }
                }

                if (price.montant === 0 || price.montant !== null) {
                    if (price.bascul_calcul === null || price.bascul_calcul === undefined) {
                        this.dataError.bascul_calcul = 'Le choix est obligatoire ';
                        hasError = true;
                    }
                    if (price.regles === null || price.regles === undefined) {
                        this.dataError.regle = 'Le choix est obligatoire ';
                        hasError = true;
                    }
                    if (price.selectedPriceId === null || price.selectedPriceId === undefined) {
                        this.dataError.list = 'Le type de prix est obligatoire ';
                        hasError = true;
                        break;
                    }
                }

                if (price.montant == 0) {
                    price.montant = null;
                }
            }
        }

        // Entrepôts
        if (this.warehouses && this.warehouses.length > 0) {
            for (let i = 0; i < this.warehouses.length; i++) {
                const warehouse = this.warehouses[i];
                if (warehouse.entrepot_id) {
                    if (warehouse.minimum === null || warehouse.minimum === undefined || warehouse.minimum === '') {
                        this.dataError.min = 'La quantité minimale est obligatoire ';
                        hasError = true;
                    }
                    if (warehouse.maximum === null || warehouse.maximum === undefined || warehouse.maximum === '') {
                        this.dataError.max = 'La quantité maximale est obligatoire ';
                        hasError = true;
                    }
                }
                if (warehouse.minimum == 0 || warehouse.minimum !== null) {
                    if (warehouse.maximum === null) {
                        this.dataError.max = 'La quantité maximale est obligatoire ';
                        hasError = true;
                    }
                    if (warehouse.entrepot_id === null) {
                        this.dataError.entrepot = 'Le dépôt est obligatoire ';
                        hasError = true;
                        break;
                    }
                }
                if (warehouse.maximum == 0 || warehouse.maximum !== null) {
                    if (warehouse.minimum === null) {
                        this.dataError.min = 'La quantité minimale est obligatoire ';
                        hasError = true;
                    }
                    if (warehouse.entrepot_id === null) {
                        this.dataError.entrepot = 'Le dépôt est obligatoire ';
                        hasError = true;
                        break;
                    }
                }
            }
        }

        // --- validations étape 2 (currentStep === 2) ---
        if (!this.product.ref_interne || !this.product.ref_interne.trim()) {
            this.dataError.ref = 'La référence du produit est obligatoire !';
            hasError = true;
        }
        const refFab = this.product.ref_fabricant != null ? String(this.product.ref_fabricant).trim() : '';
        if (!refFab) {
            this.dataError.refFabricant = 'La référence fabricant est obligatoire.';
            hasError = true;
        }
        if (this.shouldShowCodeBarreInput()) {
            const codeBar = this.product.code_barre != null ? String(this.product.code_barre).trim() : '';
            if (!codeBar) {
                this.dataError.codeBarre = 'Le code-barres est obligatoire.';
                hasError = true;
            }
        }

        // Paramètres des données (si présents)
        this.validateParamStep();
        if (!this.isStepParamDataValid) {
            hasError = true;
        }

        if (hasError) {
            this.scrollToTop();
            this.submitAttempted = true;
            return;
        }

        this.updateProduct();
    }

    protected handleEditStepCompletion(stepIndex: number): void {
        // Duplicate of add flow validation but adapted for edit (starts at step 1)
        this.dataError = {
            type: '',
            logo: '',
            nom: '',
            tva: '',
            prix_unitaires: '',
            marge: '',
            prix_vente: '',
            list: '',
            montant: '',
            ref: '',
            refFabricant: '',
            codeBarre: '',
            bascul_calcul: '',
            regle: '',
            entrepot : '',
            min : '',
            max : '',
            priceBlockErrors: [],
            warehouseBlockErrors : []
        };

        let hasError = false;

        if (stepIndex === 1) {
            if (!this.product.nom || !this.product.nom.trim()) {
                this.dataError.nom = "Le nom du produit est obligatoire";
                hasError = true;
            }

            if (!this.product.tva_id) {
                this.dataError.tva = "Le TVA est obligatoire";
                hasError = true;
            }

            if (!this.product.prix_unitaires && this.product.prix_unitaires !== 0) {
                this.dataError.prix_unitaires = "Le prix unitaire est obligatoire";
                hasError = true;
            }
            if (!this.product.prix_unitaires && this.product.prix_unitaires !== 0) {
                this.dataError.prix_vente = "Le prix vente est obligatoire";
                hasError = true;
            }
            if (!this.product.prix_unitaires && this.product.prix_unitaires !== 0) {
                this.dataError.marge = "Le marge est obligatoire";
                hasError = true;
            }

            if (this.priceLists && this.priceLists.length > 0) {
                for (let i = 0; i < this.priceLists.length; i++) {
                    const price = this.priceLists[i];

                    if (price.selectedPriceId) {
                        if (price.montant === null || price.montant === undefined || price.montant === '') {
                            this.dataError.montant = `Le montant est obligatoire `;
                            hasError = true;
                        }
                        if (price.bascul_calcul === null || price.bascul_calcul === undefined) {
                            this.dataError.bascul_calcul = `Le choix est obligatoire `;
                            hasError = true;
                        }
                        if (price.regles === null || price.regles === undefined) {
                            this.dataError.regle = `Le choix est obligatoire `;
                            hasError = true;
                            break;
                        }
                        if (!this.dataError.priceBlockErrors[i]) {
                            this.dataError.priceBlockErrors[i] = { bascul_calcul: '', regles: '' };
                        }
                    }

                    if (price.montant === 0 || price.montant !== null) {
                        if (price.bascul_calcul === null || price.bascul_calcul === undefined) {
                            this.dataError.bascul_calcul = `Le choix est obligatoire `;
                            hasError = true;
                        }
                        if (price.regles === null || price.regles === undefined) {
                            this.dataError.regle = `Le choix est obligatoire `;
                            hasError = true;
                        }
                        if (price.selectedPriceId === null || price.selectedPriceId === undefined) {
                            this.dataError.list = `Le type de prix est obligatoire `;
                            hasError = true;
                            break;
                        }
                    }

                    if (price.montant == 0) {
                        price.montant = null;
                    }
                }
            }

            if (this.warehouses && this.warehouses.length > 0) {
                for (let i = 0; i < this.warehouses.length; i++) {
                    const warehouse = this.warehouses[i];
                    if (warehouse.entrepot_id) {
                        if (warehouse.minimum === null || warehouse.minimum === undefined || warehouse.minimum === '') {
                            this.dataError.min = `La quantité minimale est obligatoire `;
                            hasError = true;
                        }
                        if (warehouse.maximum === null || warehouse.maximum === undefined || warehouse.maximum === '') {
                            this.dataError.max = `La quantité maximale est obligatoire `;
                            hasError = true;
                        }

                    }
                    if (warehouse.minimum == 0 || warehouse.minimum !== null) {

                        if (warehouse.maximum === null) {
                            this.dataError.max = `La quantité maximale est obligatoire `;
                            hasError = true;

                        }
                        if (warehouse.entrepot_id === null) {
                            this.dataError.entrepot = `Le dépôt est obligatoire `;
                            hasError = true;
                            break;
                        }
                    }
                    if (warehouse.maximum == 0 || warehouse.maximum !== null) {

                        if (warehouse.minimum === null) {
                            this.dataError.min = `La quantité minimale est obligatoire `;
                            hasError = true;

                        }
                        if (warehouse.entrepot_id === null) {
                            this.dataError.entrepot = `Le dépôt est obligatoire `;
                            hasError = true;
                            break;
                        }
                    }

                }
            }

            if (hasError) {
                this.scrollToTop();
                this.submitAttempted = true;
                return;
            }

            this.validateStep2();
            if (this.isStep2Valid) {
                this.nextStep();
            }

        } else if (stepIndex === 2) {
            // Validate reference (same as add's stepIndex === 2)
            hasError = false;
            if (!this.product.ref_interne || !this.product.ref_interne.trim()) {
                this.dataError.ref = "La référence du produit est obligatoire !";
                hasError = true;
            }

            const refFab = this.product.ref_fabricant != null ? String(this.product.ref_fabricant).trim() : '';
            if (!refFab) {
                this.dataError.refFabricant = 'La référence fabricant est obligatoire.';
                hasError = true;
            }
            if (this.shouldShowCodeBarreInput()) {
                const codeBar = this.product.code_barre != null ? String(this.product.code_barre).trim() : '';
                if (!codeBar) {
                    this.dataError.codeBarre = 'Le code-barres est obligatoire.';
                    hasError = true;
                }
            }

            if (hasError) {
                this.scrollToTop();
                this.submitAttempted = true;
                return;
            }

            this.validateStep3();
            if (this.isStep3Valid) {
                this.validateParamStep();
                this.nextStep();
            }

        } else if (stepIndex === 3) {
            this.validateParamStep();
            if (this.isStepParamDataValid) {
                this.updateProduct();
            }
        }
    }


    addNewProduct(): void {
        this.currentStep = 0;
        //this.product = {};
        this.productType = null;
        this.product.code_barre = '';
        this.product.ref_fabricant = '';
        this.isStep1Valid = false;
        this.isStep2Valid = false;
        this.isStep3Valid = false;
        this.isStepParamDataValid = true;
        this.paramTableRows = [];
        this.logoPreview = null;
        this.warehouses = [{
            entrepot_id: null,
            minimum: 0,
            maximum: 0,
            is_active_alert: false
        }];
        this.priceLists = [{
            selectedPriceId: null,
            liste: null,
            prix_id: 1,
            bascul_calcul: 'prix_public',
            regles: 'fixe',
            montant: 0,
            result_ttc: 0,
            result_ht: 0,
            priceType: 'HT',
            saisie_type: 'HT',
        }];
        this.cd.detectChanges();
    }

    private lastUpdatedProductId: number | null = null;


    updateProduct(): void {
        if (!this.productIdToEdit) return;

        if (!this.validateProductData()) {
            this.toastr.error('Veuillez remplir tous les champs obligatoires');
            return;
        }

        this.isLoading = true;

        let uploadObservable: Observable<any>;

        if (this.selectedFile) {
            // A new file is selected, prepare for upload
            const formData = new FormData();
            formData.append('file', this.selectedFile);

            // Observable for uploading the file
            uploadObservable = this.stationService.uploadFile(formData).pipe(
                tap((res: any) => {
                    if (res?.path) {
                        // Update the product object with the new image path
                        this.product.image = `${this.file_url}${res.path}`;
                        // Important: Clear the selected file after successful preparation
                        this.selectedFile = null;
                    } else {
                        // Handle missing path error and stop the chain
                        throw new Error('Réponse du serveur invalide (champ "path" manquant).');
                    }
                }),
                catchError((err) => {
                    console.error('Erreur lors du téléversement du fichier:', err);
                    this.toastr.error('Erreur lors du téléversement du fichier.');
                    // Stop the chain by returning a throwing error
                    return throwError(() => new Error('Upload Failed'));
                })
            );
        } else {
            uploadObservable = of(null);
        }

            // --- Chain the upload with the product update operation ---
        uploadObservable.pipe(

            switchMap(() => {
                if (this.shouldBulkUpdateFamilyByRef()) {
                    return this.runBulkFamilyUpdate$();
                }
                return this.productsService.updateProduct(
                    this.productIdToEdit!,
                    this.prepareProductDataForEdit()
                );
            }),

            switchMap((response) => {
                const ids = this.extractProductIdsAfterUpdate(response);
                if (ids.length === 0) {
                    return of(response);
                }
                const calls = ids.map((id) => this.saveCoordinateParams$(id));
                return forkJoin(calls).pipe(
                    map(() => response),
                    catchError((err) => {
                        this.toastr.warning(
                            err?.error?.message ||
                                'Les paramètres coordonnées n\'ont pas pu être enregistrés.',
                            'Attention'
                        );
                        return of(response);
                    })
                );
            }),

            finalize(() => {
                this.isLoading = false;
            })
        ).subscribe({
            next: (response) => {
                if (Array.isArray(response)) {
                    this.toastr.success(
                        `${response.length} produit(s) de la famille (même réf. fabricant) mis à jour avec succès`
                    );
                    const last = response[response.length - 1];
                    if (last?.product?.id) {
                        this.lastUpdatedProductId = last.product.id;
                        this.product = last.product;
                    } else {
                        this.lastUpdatedProductId = this.productIdToEdit;
                    }
                } else {
                    this.toastr.success('Produit modifié avec succès');
                    if (response && response.product && response.product.id) {
                        this.lastUpdatedProductId = response.product.id;
                        this.product = response.product;
                    } else {
                        this.lastUpdatedProductId = this.productIdToEdit;
                    }
                }

                // Update state and move to the next step
                this.currentStep = this.steps.length - 1;
                this.cd.detectChanges();
                this.refreshFeatherIcons();
            },
            error: (err) => {
                // Error handling for both upload and updateProduct
                console.error('Erreur lors de la modification/upload:', err);
                this.toastr.error(
                    err.error?.message ||
                    err.message ||
                    'Erreur lors de la modification du produit'
                );
            }
        });
    }

    toggleStep(step: any) {
        step.completed = !step.completed;
    }

    productType: 'matériel' | 'service' | 'financier' | null = null;

    selectType(type: 'matériel' | 'service' | 'financier') {
        this.productType = type;
        this.product.type = type;
        this.dataError.type = '';
        this.validateStep1();
        this.refreshFeatherIcons();
    }

    refreshFeatherIcons(): void {
        setTimeout(() => {
            if (typeof feather !== 'undefined') {
                feather.replace();
            }
            this.cd.detectChanges();
        }, 100);
    }

    productId: number | null = null;
    originalProductId: number | null = null;

    detail(productID?: number) {
        // Priority: last created -> last updated -> original edit ID
        const productId = this.lastCreatedProductId || this.lastUpdatedProductId || this.productIdToEdit;

        if (productId && productId > 0) {
            // console.log('Navigating to product ID:', productId);
            this.router.navigate(['/bibliotheque-test/detail-produit', productId, 'vue-ensemble']);
        } else {
            console.error('No valid product ID found');
            this.toastr.warning('Impossible de trouver le produit. Redirection vers la liste.');
            this.router.navigate(['/produits-services']);
        }
    }

    private getEffectiveProductId(productID?: number): number | null {
        // Priority order: passed parameter > product object > component properties
        if (productID && this.isValidId(productID)) return productID;
        if (this.product?.id && this.isValidId(this.product.id)) return this.product.id;
        if (this.productId && this.isValidId(this.productId)) return this.productId;
        if (this.originalProductId && this.isValidId(this.originalProductId)) return this.originalProductId;

        return null;
    }

    private isValidId(id: any): boolean {
        return id != null && !isNaN(Number(id)) && Number(id) > 0;
    }

    private handleNavigationError(invalidId: any) {
        console.error('Product navigation failed. Debug info:', {
            product: this.product,
            productId: this.productId,
            originalProductId: this.originalProductId,
            invalidId: invalidId
        });

        this.toastr.error(
            `Navigation impossible : ID Produit manquant ou invalide. Vérifiez les logs console.`,
            'Erreur Critique'
        );
    }




    addWarehouse() {
        if (this.warehouses.length < 5) {
            this.warehouses.push({
                entrepot_id :0,
                minimum: 0,
                maximum: 0,
                is_active_alert: false
            });
        } else {
            this.toasterInfo("Vous ne pouvez pas ajouter plus de 5 entrepôts.");
        }
    }

    toasterInfo(msg: string): void {
        this.toastr.info(msg, '', {
            positionClass: 'toast-bottom-right',
            toastClass: 'toast ngx-toastr',
            closeButton: true
        });
    }

    removeWarehouse(index: number) {
        if (this.warehouses.length > 1) {
            this.warehouses.splice(index, 1);
        } else {
            this.toasterInfo("Vous ne pouvez pas supprimer tous les entrepôts");
        }
    }

    increment(index: number) {
        this.warehouses[index].minimum++;
    }

    decrement(index: number) {
        if (this.warehouses[index].minimum > 0) {
            this.warehouses[index].minimum--;
        }
    }

    incrementMax(index: number) {
        this.warehouses[index].maximum++;
    }

    decrementMax(index: number) {
        if (this.warehouses[index].maximum > 0) {
            this.warehouses[index].maximum--;
        }
    }

    addPriceList() {
        if (this.priceLists.length < 3) {
            this.priceLists.push({
                prix_id: 0,
                bascul_calcul: 'prix_public',
                liste: null,
                regles: 'fixe',
                montant: 0,
                result_ttc: 0,
                result_ht: 0,
                priceType: 'HT',
                saisie_type: 'HT',
                selectedPriceId: null
            });
        } else {
            this.toasterInfo("Vous ne pouvez pas ajouter plus de 3.");
        }
    }

    removePriceList(index: number) {
        if (this.priceLists.length > 1) {
            this.priceLists.splice(index, 1);
        }
    }

    loadPrix(): void {
        this.isLoading = true;
        this.prixService.getPrix(this.stationId).subscribe({
            next: (data: any) => {
                const allPrices = data.prixListe || data;
                this.availablePriceLists = allPrices.filter((price: any) => price.statut === true);
                this.isLoading = false;
                this.cd.detectChanges();
            },
            error: (err) => {
                this.toastr.error('Erreur lors du chargement des prix', err);
                this.isLoading = false;
                this.cd.detectChanges();
            }
        });
    }

    loadTaxe(): void {
        this.isLoading = true;
        this.taxeService.getTaxeList(this.stationId).subscribe({
            next: (data: any) => {
                const list = data?.taxes || [];

                this.taxes = list.filter((t: any) => {
                    const statut = t.statut === true || t.statut === 1 || t.statut === '1' || t.statut === 'true';
                    const applique = t.taxe_applique_sur_produits === true || t.taxe_applique_sur_produits === 1 || t.taxe_applique_sur_produits === '1' || t.taxe_applique_sur_produits === 'true';
                    return statut && applique;
                });

                this.isLoading = false;
                this.cd.detectChanges();
            },
            error: () => {
                this.toastr.error('Erreur lors du chargement des taxes');
                this.isLoading = false;
                this.cd.detectChanges();
            }
        });
    }


    loadTVA(): void {
        this.isLoading = true;
        this.tvaService.getTvaList(this.stationId).subscribe({
            next: (data: any) => {
                this.tva = (data.tvaListe || []).filter((t: any) => t.statut === true);
                // console.log("TVA actives :", this.tva);
                this.isLoading = false;
                this.cd.detectChanges();
            },
            error: (err) => {
                this.toastr.error('Erreur lors du chargement des TVA');
                this.isLoading = false;
                this.cd.detectChanges();
            }
        });
    }

    loadMarques(): void {
        if (this.clientId && this.stationId) {
            this.isLoading = true;
            this.marqueService.getAll(this.stationId, this.clientId).subscribe({
                next: (marques) => {
                    this.marques = [...marques];
                    this.isLoading = false;
                    if (marques.length === 0) {
                        // this.toastr.info('Aucune marque trouvée pour cette station.', 'Information');
                    }
                    this.cdr.detectChanges();
                },
                error: (error) => {
                    this.isLoading = false;
                    this.toastr.error(error.message || 'Erreur lors du chargement des marques.', 'Erreur');
                }
            });
        } else {
            this.toastr.error('Informations utilisateur ou station manquantes.', 'Erreur');
        }
    }

    loadCategories(): void {
        if (this.clientId && this.stationId) {
            this.isLoading = true;
            this.categorieService.getAll(this.stationId, this.clientId).subscribe({
                next: (categories) => {
                    this.categories = [...categories];
                    this.isLoading = false;
                    if (categories.length === 0) {
                        //  this.toastr.info('Aucune catégorie trouvée pour cette station.', 'Information');
                    }
                    this.cdr.detectChanges();
                },
                error: (error) => {
                    this.isLoading = false;
                    this.toastr.error(error.message || 'Erreur lors du chargement des catégories.', 'Erreur');
                }
            });
        } else {
            this.toastr.error('Informations utilisateur ou station manquantes.', 'Erreur');
        }
    }

    loadUnites(): void {
        if (this.clientId && this.stationId) {
            this.isLoading = true;
            this.uniteService.getAll(this.stationId, this.clientId).subscribe({
                next: (unites) => {
                    this.unites = [...unites];
                    this.isLoading = false;
                    //  console.log('Units loaded:', this.unites);
                    if (unites.length === 0) {
                        //   this.toastr.info('Aucune unité trouvée pour cette station.', 'Information');
                    }
                    this.cdr.detectChanges();
                },
                error: (error) => {
                    this.isLoading = false;
                    this.toastr.error(error.message || 'Erreur lors du chargement des unités.', 'Erreur');
                }
            });
        } else {
            this.toastr.error('Informations utilisateur ou station manquantes.', 'Erreur');
        }
    }

    onPriceSelected(index: number, selectedId: number): void {
        this.priceLists[index].prix_id = selectedId;
        this.cd.detectChanges();
    }
    onEntrepotSelected(index: number, selectedId: number): void {
        this.warehouses[index].entrepot_id = selectedId;
        this.cd.detectChanges();
    }

    incrementAmount(index: number) {
        this.priceLists[index].montant++;
        this.calculateResults(index);
        this.clearFieldError('montant');
    }

    decrementAmount(index: number): void {
        if (this.priceLists[index].montant > 1) {
            this.priceLists[index].montant--;
            this.calculateResults(index);
            this.clearFieldError('montant');
        }
    }

    /* calculateResults(index: number): void {
         const price = this.priceLists[index];
         const decimalPlaces = 3;


         if (price.montant == null) {
             price.montant = 0;
             price.result_ht = 0;
             price.result_ttc = 0;

         }

         const calculated_ht = price.montant;
         price.result_ht = parseFloat(calculated_ht.toFixed(decimalPlaces));
         const calculated_ttc = price.montant * 1.2;
         price.result_ttc = parseFloat(calculated_ttc.toFixed(decimalPlaces));
     } */

    private validateProductData(): boolean {
        if (!this.product.type) {
            this.toastr.error('Le type de produit est requis');
            return false;
        }
        if (!this.product.nom || this.product.nom.trim() === '') {
            this.toastr.error('Le nom du produit est requis');
            return false;
        }
        if (!this.product.prix_unitaires) {
            this.toastr.error('Le prix unitaire est requis');
            return false;
        }
        const refFab = this.product.ref_fabricant != null ? String(this.product.ref_fabricant).trim() : '';
        if (!refFab) {
            this.toastr.error('La référence fabricant est requise');
            return false;
        }
        if (this.shouldShowCodeBarreInput()) {
            const codeBar = this.product.code_barre != null ? String(this.product.code_barre).trim() : '';
            if (!codeBar) {
                this.toastr.error('Le code-barres est requis');
                return false;
            }
        }

        return true;
    }

    private prepareProductData(): any {
        const productData = {
            type: this.product.type,
            nom: this.product.nom,
            tva_id: this.product.tva_id,
            taxes: this.prepareTaxes(),
            prix_unitaires: this.product.prix_unitaires,
            result_ht : this.product.result_ht,
            result_ttc : this.product.result_ttc,
            autoriser_vente_stock_vide : this.product.autoriser_vente_stock_vide,
            produit_avec_numero_serie : this.product.produit_avec_numero_serie,
            image: this.product.image,
            marque_id: this.product.marque_id,
            categories_id: this.product.categories_id,
            unite_id: this.product.unite_id,
            ref_interne: this.product.ref_interne,
            ref_fabricant: this.product.ref_fabricant,
            code_barre: this.normalizeOptionalString(this.product.code_barre),
            description: this.product.description,
            station_id: this.stationId,
            client_id: this.clientId,
            liste_prix: this.preparePriceLists(),
            information_logistique: this.product.type === 'matériel' ? this.prepareWarehouses() : []
        };

        // console.log('Warehouses data prepared:', productData.information_logistique);
        return productData;
    }

    /** Chaîne trim ; chaîne vide → undefined pour l’API. */
    private normalizeOptionalString(v: string | null | undefined): string | undefined {
        if (v == null || typeof v !== 'string') {
            return undefined;
        }
        const t = v.trim();
        return t === '' ? undefined : t;
    }

    /**
     * Même logique que la liste produits : code-barres vide, 0 ou null = ligne « parent » de famille (réf. fabricant).
     */
    private isFamilyPrimaryStyleBarcode(code_barre: any): boolean {
        const c = code_barre;
        if (c == null || c === '') {
            return true;
        }
        const s = String(c).trim();
        if (s === '' || s === '0') {
            return true;
        }
        const n = Number(s.replace(',', '.'));
        return !Number.isNaN(n) && n === 0;
    }

    /**
     * En création : toujours afficher le code-barres.
     * En édition : le masquer pour le produit parent de famille (code-barres null / vide / 0).
     */
    shouldShowCodeBarreInput(): boolean {
        if (this.mode !== 'edit') {
            return true;
        }
        return !this.isFamilyPrimaryStyleBarcode(this.product?.code_barre);
    }

    /** Édition « ligne famille » : code-barres parent vide + même ref. fabricant → PUT pour toute la famille. */
    private shouldBulkUpdateFamilyByRef(): boolean {
        if (this.mode !== 'edit' || !this.productIdToEdit) {
            return false;
        }
        if (!this.isFamilyPrimaryStyleBarcode(this.product?.code_barre)) {
            return false;
        }
        const ref = this.normalizeRefFabricantValue(
            this.product.ref_fabricant ?? (this.product as any).ref_fabriquant
        );
        return ref !== '';
    }

    private normalizeRefFabricantValue(raw: any): string {
        if (raw == null) {
            return '';
        }
        return String(raw).trim();
    }

    /** Ref. fabricant côté API (plusieurs clés possibles selon liste vs détail). */
    private extractRefFabricantFromApiRow(p: any): string {
        if (!p) {
            return '';
        }
        return this.normalizeRefFabricantValue(
            p.ref_fabricant ??
                p.ref_fabriquant ??
                p.refFabriquant ??
                p.reference_fabricant ??
                p.product?.ref_fabricant ??
                p.product?.ref_fabriquant
        );
    }

    private refFabricantMatches(a: string, b: string): boolean {
        if (!a || !b) {
            return false;
        }
        return a.localeCompare(b, 'fr', { sensitivity: 'base' }) === 0;
    }

    /** ID station valide pour les appels `GET .../station/:id` (évite `!stationId` qui échoue si `id` absent). */
    private resolveStationIdForProductsApi(): number | null {
        const u = this.currentUser;
        const raw =
            u?.stations?.[0]?.station_id ??
            u?.stations?.[0]?.id ??
            u?.station_id ??
            this.stationId;
        if (raw === null || raw === undefined || raw === '') {
            return null;
        }
        const n = Number(raw);
        return Number.isFinite(n) && n > 0 ? n : null;
    }

    private isProductArchivedRow(p: any): boolean {
        const v = p?.is_archive ?? p?.isArchive;
        return v === true || v === 1 || v === '1';
    }

    /** Charge tous les produits de la station (toutes les pages). */
    private loadAllProductsForStation(): Observable<Product[]> {
        const sid = this.resolveStationIdForProductsApi();
        if (sid == null) {
            return of([]);
        }
        const limit = 500;
        const load = (page: number, acc: Product[]): Observable<Product[]> => {
            return this.productsService.getProductsByStationId(sid, page, limit, false).pipe(
                switchMap((raw: any) => {
                    const pageRows: Product[] = Array.isArray(raw?.data)
                        ? raw.data
                        : Array.isArray(raw?.products)
                            ? raw.products
                            : [];
                    const merged = [...acc, ...pageRows];
                    const metaTotal = raw.meta?.total;
                    const totalPagesMeta = raw.meta?.pages ?? raw.meta?.nb_total_pages;

                    if (pageRows.length === 0) {
                        return of(merged);
                    }
                    if (totalPagesMeta != null && page >= totalPagesMeta) {
                        return of(merged);
                    }
                    if (metaTotal != null && merged.length >= metaTotal) {
                        return of(merged);
                    }
                    if (pageRows.length < limit) {
                        return of(merged);
                    }
                    return load(page + 1, merged);
                })
            );
        };
        return load(1, []);
    }

    /** IDs des produits avec la même ref. fabricant (non archivés). */
    private getProductIdsWithSameRefFabricant$(): Observable<number[]> {
        const ref = this.normalizeRefFabricantValue(
            this.product.ref_fabricant ?? (this.product as any).ref_fabriquant
        );
        const sid = this.resolveStationIdForProductsApi();
        if (!ref || sid == null) {
            return of(this.productIdToEdit ? [this.productIdToEdit] : []);
        }
        return this.loadAllProductsForStation().pipe(
            map((products) => {
                const ids = new Set<number>();
                for (const p of products) {
                    const pRef = this.extractRefFabricantFromApiRow(p);
                    if (
                        this.refFabricantMatches(pRef, ref) &&
                        p.id != null &&
                        !this.isProductArchivedRow(p)
                    ) {
                        ids.add(p.id as number);
                    }
                }
                if (ids.size === 0 && this.productIdToEdit) {
                    ids.add(this.productIdToEdit);
                }
                return Array.from(ids).sort((a, b) => a - b);
            })
        );
    }

    /**
     * Même corps de requête que le formulaire ; pour les variantes (autre id), conserver champs propres au SKU.
     */
    private mergeFamilyUpdatePayload(detail: Product): any {
        const base = this.prepareProductDataForEdit();
        if (detail.id === this.productIdToEdit) {
            return base;
        }
        const code =
            detail.code_barre != null && String(detail.code_barre).trim() !== ''
                ? this.normalizeOptionalString(String(detail.code_barre)) ?? String(detail.code_barre).trim()
                : base.code_barre;
        /* Même nom pour toute la famille (formulaire) ; ref_interne / code-barres / couleur / taille par variante. */
        return {
            ...base,
            ref_interne: detail.ref_interne ?? base.ref_interne,
            code_barre: code,
            couleur: detail.couleur ?? base.couleur,
            taille: detail.taille ?? base.taille
        };
    }

    private runBulkFamilyUpdate$(): Observable<any> {
        return this.getProductIdsWithSameRefFabricant$().pipe(
            switchMap((ids) => {
                if (ids.length <= 1) {
                    return this.productsService.updateProduct(
                        this.productIdToEdit!,
                        this.prepareProductDataForEdit()
                    );
                }
                return forkJoin(
                    ids.map((id) =>
                        this.productsService.getDetailsProduct(id).pipe(
                            switchMap((detail) =>
                                this.productsService.updateProduct(id, this.mergeFamilyUpdatePayload(detail))
                            )
                        )
                    )
                );
            })
        );
    }

    // Add a unique identifier for the component instance
    uniqueId: string = Math.random().toString(36).substring(2);
    private prepareProductDataForEdit(): any {
        const productData = {
            type: this.product.type,
            nom: this.product.nom,
            tva_id: this.product.tva_id,
            taxes: this.prepareTaxes(),
            prix_unitaires: this.product.prix_unitaires,
            result_ht : this.product.result_ht,
            result_ttc : this.product.result_ttc,
            autoriser_vente_stock_vide : !!this.product.autoriser_vente_stock_vide,
            produit_avec_numero_serie : !!this.product.produit_avec_numero_serie,
            image: this.product.image,
            marque_id: this.product.marque_id,
            categories_id: this.product.categories_id,
            unite_id: this.product.unite_id,
            ref_interne: this.product.ref_interne,
            ref_fabricant: this.product.ref_fabricant,
            code_barre: this.normalizeOptionalString(this.product.code_barre),
            description: this.product.description,
            station_id: this.stationId,
            client_id: this.clientId,
            liste_prix: this.preparePriceLists(),
            information_logistique: this.product.type === 'matériel' ? this.prepareWarehouses() : []
        };

        return productData;
    }

    private preparePriceLists(): any[] {
        if (!this.priceLists || this.priceLists.length === 0) {
            return [];
        }
        return this.priceLists
            .filter(price => price.montant != null && true)
            .map(price => ({
                prix_id: price.prix_id,
                bascul_calcul: price.bascul_calcul,
                regles: price.regles,
                montant: Number(price.montant),
                result_ttc: price.result_ttc || 0,
                result_ht: price.result_ht || 0,
                client_id: this.clientId,
                station_id: this.stationId
            }));
    }

    private prepareWarehouses(): any[] {

        const validWarehouses = this.warehouses.filter(warehouse =>
            warehouse.entrepot_id && warehouse.entrepot_id > 0
        );

        const warehousesData = validWarehouses.map(warehouse => ({
            entrepot_id: warehouse.entrepot_id,
            minimum: warehouse.minimum,
            maximum: warehouse.maximum,
            is_active_alert: !!warehouse.is_active_alert,
            client_id: this.clientId,
            station_id: this.stationId
        }));

        // console.log('Prepared warehouses data:', warehousesData);
        return warehousesData;
    }

    private prepareTaxes(): any[] {
        if (!this.product.taxes || this.product.taxes.length === 0) {
            return [];
        }

        return this.product.taxes.map(taxe => ({
            taxe_id: taxe.id,
            nom: taxe.nom,
            label: taxe.label,
            valeur: taxe.valeur,
            valeur_fixe: taxe.valeur_fixe,
            valeur_pourcentage: taxe.valeur_pourcentage,
            applique_avant_tva: taxe.applique_avant_tva,
            applique_apres_tva: taxe.applique_apres_tva,
            type: taxe.type,
            client_id: this.clientId,
            station_id: this.stationId
        }));
    }


    lastCreatedProductId: number | null = null;

    saveProduct(): void {
        if (!this.validateProductData()) {
            this.toastr.error('Veuillez remplir tous les champs obligatoires');
            return;
        }
        this.isLoading = true;
        let uploadObservable: Observable<any>;

        if (this.selectedFile) {
            const formData = new FormData();
            formData.append('file', this.selectedFile);

            uploadObservable = this.stationService.uploadFile(formData).pipe(
                tap((res: any) => {
                    if (res?.path) {
                        this.product.image = `${this.file_url}${res.path}`;
                    } else {
                        throw new Error('Réponse du serveur invalide (champ "path" manquant).');
                    }
                }),
                catchError((err) => {
                    console.error('Erreur lors du téléversement du fichier:', err);
                    this.toastr.error('Erreur lors du téléversement du fichier.');
                    return throwError(() => new Error('Upload Failed'));
                })
            );
        } else {
            uploadObservable = of(null);
        }

        uploadObservable.pipe(
            switchMap(() => {
                // Prepare data ONLY HERE, after potential image update
                const productToSave = this.prepareProductData();
                console.log("to save : ", productToSave);


                return this.productsService.addProduct(this.stationId, productToSave);
            }),
            switchMap((response) => {
                const pid = response?.product?.id;
                if (pid == null || !Number.isFinite(Number(pid))) {
                    return of(response);
                }
                return this.saveCoordinateParams$(Number(pid)).pipe(
                    map(() => response),
                    catchError((err) => {
                        this.toastr.warning(
                            err?.error?.message ||
                                'Les paramètres coordonnées n\'ont pas pu être enregistrés.',
                            'Attention'
                        );
                        return of(response);
                    })
                );
            }),
            finalize(() => {
                this.isLoading = false;
            })
        ).subscribe({
            next: (response) => {
                console.log('saved product ',response);
                this.toastr.success('Produit ajouté avec succès');

                if (response && response.product && response.product.id) {
                    this.lastCreatedProductId = response.product.id;
                    this.product = response.product;
                } else {
                    console.error('Product ID not found in response:', response);
                    this.lastCreatedProductId = null;
                }
                this.selectedFile = null;
                this.nextStep();
            },
            error: (err) => {
                console.error('Erreur lors de l\'ajout/upload:', err);
                this.toastr.error(
                    err.error?.message ||
                    err.message ||
                    'Erreur lors de l\'ajout du produit'
                );
            }
        });
    }


    openModal(type: 'ajouter' | 'update' | 'etat' = 'ajouter', item?: Tva | Taxe, statut?: boolean, subType?: string): void {

        const target = subType; // Remove the fallback to activeTab

        if (target === 'tva') {
            this.api.openTvaModal(type, item as Tva, statut);
        } else if (target === 'taxe') {
            this.api.openTaxeModal(type, item as Taxe, statut);
        } else {
            console.error('TaxeTvaComponent: Component not available:', {
                target
            });
        }
    }

    addMarque(idStation: number): void {
        const modalRef = this.modalService.open(CroudMarqueCategoryComponent, {
            size: 'lg',
            centered: true,
            backdrop: 'static',
            keyboard: false
        });
        modalRef.componentInstance.modalSubType = 'marque';
        modalRef.componentInstance.idStation = this.stationId;
        modalRef.result.then(
            (newMarque: Marque) => {
                this.ngZone.run(() => {
                    if (newMarque && newMarque.libelle && newMarque.id > 0) {
                        // Add new marque to the beginning of the array
                        this.marques = [newMarque, ...this.marques];

                        // Set the newly added marque as selected
                        this.product.marque_id = newMarque.id;

                        setTimeout(() => {
                            this.cdr.detectChanges();
                        }, 0);
                    } else {
                        this.toastr.warning('Marque non ajoutée localement, actualisation de la liste.', 'Avertissement');
                        // Optionally refresh the list if marque wasn't added properly
                        this.loadMarques();
                    }
                });
            },
            (reason) => {
                this.ngZone.run(() => {
                    // console.log('Modal dismissed:', reason);
                    if (reason === 'Erreur lors de l\'enregistrement') {
                        this.toastr.error('Erreur lors de l\'ajout, actualisation de la liste.', 'Erreur');
                        this.loadMarques();
                    }
                });
            }
        ).catch((error) => {
            console.error('Modal promise error:', error);
            this.ngZone.run(() => {
                this.toastr.error('Erreur inattendue lors de la fermeture du modal.', 'Erreur');
                this.loadMarques();
            });
        });
    }

    addCategory(idStation: number): void {
        const modalRef = this.modalService.open(CroudMarqueCategoryComponent, {
            size: 'lg',
            centered: true,
            backdrop: 'static',
            keyboard: false
        });
        modalRef.componentInstance.modalSubType = 'catégorie';
        modalRef.componentInstance.idStation = this.stationId;
        modalRef.result.then(
            (newCategory: Categorie) => {
                this.ngZone.run(() => {
                    if (newCategory && newCategory.libelle && newCategory.id > 0) {
                        // Add new category to the beginning of the array
                        this.categories = [newCategory, ...this.categories];

                        // Set the newly added category as selected
                        this.product.categories_id = newCategory.id;


                        setTimeout(() => {
                            this.cdr.detectChanges();
                            //  console.log('Change detection triggered');
                        }, 0);
                    } else {
                        console.warn('Invalid category received:', newCategory);
                        this.toastr.warning('Catégorie non ajoutée localement, actualisation de la liste.', 'Avertissement');
                        this.loadCategories();
                    }
                });
            },
            (reason) => {
                this.ngZone.run(() => {
                    //  console.log('Modal dismissed:', reason);
                    if (reason === 'Erreur lors de l\'enregistrement') {
                        this.toastr.error('Erreur lors de l\'ajout, actualisation de la liste.', 'Erreur');
                        this.loadCategories();
                    }
                });
            }
        ).catch((error) => {
            console.error('Modal promise error:', error);
            this.ngZone.run(() => {
                this.toastr.error('Erreur inattendue lors de la fermeture du modal.', 'Erreur');
                this.loadCategories();
            });
        });
    }

    addUnite(idStation: number): void {
        const modalRef = this.modalService.open(CroudMarqueCategoryComponent, {
            size: 'lg',
            centered: true,
            backdrop: 'static',
            keyboard: false
        });
        modalRef.componentInstance.modalSubType = 'unité';
        modalRef.componentInstance.idStation = this.stationId;
        modalRef.result.then(
            (newunite: Categorie) => {
                this.ngZone.run(() => {
                    if (newunite && newunite.libelle && newunite.id > 0) {
                        // Add new category to the beginning of the array
                        this.unites = [newunite, ...this.unites];

                        // Set the newly added category as selected
                        this.product.unite_id = newunite.id;


                        setTimeout(() => {
                            this.cdr.detectChanges();
                            //  console.log('Change detection triggered');
                        }, 0);
                    } else {
                        console.warn('Invalid category received:', newunite);
                        this.toastr.warning('Catégorie non ajoutée localement, actualisation de la liste.', 'Avertissement');
                        this.loadUnites();
                    }
                });
            },
            (reason) => {
                this.ngZone.run(() => {
                    //  console.log('Modal dismissed:', reason);
                    if (reason === 'Erreur lors de l\'enregistrement') {
                        this.toastr.error('Erreur lors de l\'ajout, actualisation de la liste.', 'Erreur');
                        this.loadUnites();
                    }
                });
            }
        ).catch((error) => {
            console.error('Modal promise error:', error);
            this.ngZone.run(() => {
                this.toastr.error('Erreur inattendue lors de la fermeture du modal.', 'Erreur');
                this.loadUnites();
            });
        });
    }

    ngAfterViewInit(): void {
        this.subscriptions.add(
            this.api.onTvaAdded().subscribe(() => {
                this.loadTVA();
                setTimeout(() => {
                    if (this.tva && this.tva.length > 0) {
                        this.product.tva_id = this.tva[0].id;
                    }
                }, 100);
            })
        );
        if (this.addtaxe && this.addtaxe.taxeAdded) {
            this.addtaxe.taxeAdded.subscribe(() => {
                this.loadTaxe();
                // Select the first taxe after reloading (assuming newest is first)
                setTimeout(() => {
                    if (this.taxes && this.taxes.length > 0) {
                        this.product.taxe_id = this.taxes[0].id;

                    }
                }, 100);
            });
        }
    }


    addtva(type: 'tva' | 'taxe'): void {
        if (type === 'tva') {
            this.api.openTvaModal('ajouter');
        } else {
            console.error('Component not available:', type);
        }
    }

    addTaxes(): void {
        if (!this.addtaxe) {
            console.error('AddTaxeComponent not initialized.');
            this.toastr.error('Erreur: Composant de Taxe non disponible.', 'Erreur');
            return;
        }

        this.addtaxe.openModal();
    }

    clearPriceListSelection(index: number) {
        if (this.priceLists[index]) {
            // Clear the Type selection
            this.priceLists[index].selectedPriceId = null;

            // Reset the other fields
            // this.priceLists[index].bascul_calcul = null;
            // this.priceLists[index].regles = null;
            this.priceLists[index].montant = null;
            this.priceLists[index].result_ttc = 0;
            this.priceLists[index].result_ht = 0;
            this.clearFieldError('montant');
            this.clearFieldError('bascul_calcul');
            this.clearFieldError('regle');
            this.clearFieldError('list');

        }
    }
    clearWarehouseListSelection(index: number) {
        if (this.warehouses[index]) {
            // Clear the Type selection
            this.warehouses[index].entrepot_id = null;

            this.warehouses[index].minimum = null;
            this.warehouses[index].maximum = null;

            this.clearFieldError('entrepot');
            this.clearFieldError('min');
            this.clearFieldError('max');


        }
    }

    allEntrepot: any []

    getAllEntrepots(): void {
        this.warehouseService.getAllWarehouses(this.clientId, this.stationId).subscribe({
            next: (warehouses) => {
                this.allEntrepot = warehouses;

            },
            error: (err) => console.error(err)
        });

    }
    isTaxeSelected(taxeId: number): boolean {
        if (!this.product.taxes || !Array.isArray(this.product.taxes)) {
            return false;
        }
        // Check both 'id' and 'taxes_id' to handle different data structures
        return this.product.taxes.some(t => {
            if (!t) return false;
            // Check if the taxe has the matching ID (either in 'id' or 'taxes_id')
            const taxeAny = t as any;
            return (t.id === taxeId) || (taxeAny.taxes_id === taxeId) || (taxeAny.taxe_id === taxeId);
        });
    }

    toggleTaxe(taxe: Taxe, checked: boolean): void {
        // Ensure taxes is always an array
        if (!this.product.taxes || !Array.isArray(this.product.taxes)) {
            this.product.taxes = [];
        }

        if (checked) {
            if (!this.isTaxeSelected(taxe.id)) {
                this.product.taxes.push(taxe);
            }
        } else {
            this.product.taxes = this.product.taxes.filter(t => t && t.id !== taxe.id);
        }
    }

}
